const autoNgTemplateLoaderTemplate1 = require('./certificates.template.html');

'use strict';

(function () {
    angular
        .module('app.certificates', [])
        .config(certificatesConfig);

    certificatesConfig.$inject = ['$routeProvider'];

    function certificatesConfig($routeProvider) {
        $routeProvider
            .when('/certificates', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'CertificatesController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                }
            })
    }
})();
